<script>
	import { onMount } from "svelte";
	
	let cookies;
	let scrolledBefore = 0;
	let transform = (factor, rotation) => {
		return `scale(1) rotate(${rotation}deg)`;
	}
	let rotations = [];
	
	function animateCookies() {
		const rightContainer = document.querySelector('.container > .right');
		const scrolled = rightContainer ? rightContainer.scrollTop : 0;
		if(scrolledBefore !== scrolled) {
			transform = (factor, rotation) => {
				return `scale(1) translateY(${scrolled * factor}px) rotate(${rotation}deg)`;
			}
		}
		scrolledBefore = scrolled;
		requestAnimationFrame(animateCookies);
	}
	function cookiesInNowPage(element) {
		if(!element.parentElement) {
			return false;
		}
		return element.parentElement.classList.contains('now') || cookiesInNowPage(element.parentElement);
	}
	function shuffleArray(a) {
		for (let i = a.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[a[i], a[j]] = [a[j], a[i]];
		}
		return a;
	}
	
	onMount(() => {
		let cookieCounter = 11;
		let angle = 360 / cookieCounter;
		for (let i = 0; i < cookieCounter; i++) {
			rotations[i] = angle * i;
		}
		rotations = shuffleArray(rotations);
		if(cookiesInNowPage(cookies)) {
			animateCookies();
		}
	})
</script>

<div class="cookie-container" bind:this={cookies}>
	<div class="cookie front-group" style="transform: {transform(-1, rotations[0])}"></div>
	<div class="cookie front-group" style="transform: {transform(-1, rotations[1])}"></div>
	<div class="cookie middle-group" style="transform: {transform(-0.5, rotations[2])}"></div>
	<div class="cookie middle-group" style="transform: {transform(.3, rotations[3])}"></div>
	<div class="cookie middle-group" style="transform: {transform(.3, rotations[4])}"></div>
	<div class="cookie middle-group" style="transform: {transform(.3, rotations[5])}"></div>
	<div class="cookie middle-group" style="transform: {transform(.3, rotations[6])}"></div>
	<div class="cookie rear-group" style="transform: {transform(.6, rotations[7])}"></div>
	<div class="cookie rear-group" style="transform: {transform(.6, rotations[8])}"></div>
	<div class="cookie rear-group" style="transform: {transform(.6, rotations[9])}"></div>
	<div class="cookie rear-group" style="transform: {transform(.6, rotations[10])}"></div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	.cookie {
		background: url("../img/10.Appetit_Digitalisieren/01.cookies/cookie-single.webp");
		background-repeat: no-repeat;
		background-size: cover;
	}
	
	div.cookie {
		position: absolute;
	}
	
	.cookie-container {
		width: 100%;
		height: auto;
		transform: scale(.5);
		position: absolute;
		right: -180px;
		top: 0;
		z-index: -1;

		@include for-tablet-landscape-up {
			transform: scale(.7);
			right: -100px;
			top: -45px;
		}
		
		@include for-desktop-up {
			transform: scale(1);
			right: 0;
		}
		
		@include for-big-desktop-up {
			right: 10vw;
		}
	}
	
	div.cookie:first-of-type {
		width: 200px;
		height: 200px;
		top: 100px;
		right: 320px;
	}
	
	div.cookie:nth-of-type(2) {
		width: 200px;
		height: 200px;
		top: -100px;
		right: 100px;
	}
	
	div.cookie:nth-of-type(3) {
		width: 90px;
		height: 90px;
		top: 84px;
		right: 70px;
	}
	
	div.cookie:nth-of-type(4) {
		width: 95px;
		height: 95px;
		top: 175px;
		right: 215px;
	}
	
	div.cookie:nth-of-type(5) {
		width: 80px;
		height: 80px;
		top: 60px;
		right: 272px;
	}
	
	div.cookie:nth-of-type(6) {
		width: 75px;
		height: 75px;
		top: 40px;
		right: 170px;
	}
	
	div.cookie:nth-of-type(7) {
		width: 60px;
		height: 60px;
		top: -40px;
		right: 340px;
		opacity: 0.75;
	}
	
	div.cookie:nth-of-type(8) {
		width: 55px;
		height: 55px;
		top: 50px;
		right: 500px;
		opacity: 0.75;
	}
	
	div.cookie:nth-of-type(9) {
		width: 50px;
		height: 50px;
		top: 20px;
		right: 40px;
		opacity: 0.85;
	}
	
	div.cookie:nth-of-type(10) {
		width: 35px;
		height: 35px;
		top: 120px;
		right: 210px;
		opacity: 0.75;
	}
	
	div.cookie:nth-of-type(11) {
		width: 40px;
		height: 40px;
		top: 133px;
		right: 250px;
		z-index: -3;
		opacity: 0.85;
	}
	
	.middle-group {
		filter: blur(1px);
		z-index: -1;
	}
	
	.rear-group {
		filter: blur(1.5px);
		z-index: -3;
	}
</style>

